import { render, staticRenderFns } from "./AffiliateSchool.vue?vue&type=template&id=d413dbb4&"
import script from "./AffiliateSchool.vue?vue&type=script&lang=js&"
export * from "./AffiliateSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports